module.exports = __webpack_public_path__ + "static/media/icon-app.92e19b7f.svg";